import { ReactNode } from 'react'

import { AvatarLetter, CustomAvatar } from './styles'

interface IProps {
  children: ReactNode
  height: number
  width: number
}

export function Avatar({ children, ...rest }: IProps) {
  return (
    <CustomAvatar {...rest}>
      <AvatarLetter>{children}</AvatarLetter>
    </CustomAvatar>
  )
}
